"use client";

import { useState } from "react";
import { Row, Col, Form, FloatingLabel } from "react-bootstrap";
import { Link } from "react-router-dom";

import * as myApi from "../../Api";
import { validateEmail } from "../../../utils/formValidation";

import { showLoading } from "react-global-loading";
import { toast } from "react-toastify";

const resetPassword = async (event, setEmailError) => {
  event.preventDefault();

  showLoading(true);

  const formData = new FormData(event.currentTarget);
  const email = formData.get("email");

  // Validate email format
  const emailValidation = validateEmail(email);
  if (!emailValidation.valid) {
    toast(emailValidation.message, { type: "error" });
    setEmailError(emailValidation.message);
    showLoading(false);
    return;
  }

  if (email === "") {
    toast("Email cannot be empty", { type: "error" });
    showLoading(false);
    return;
  }
  setEmailError('');
  
  try {
    const response = await myApi.post("/checkmail", { data_email: email });

    if (response.status === 200) {
      await myApi
        .post("/forgotpwd", { data_email: email, data_kode: 'passwd' })
        .then((response) => {
          showLoading(false);
          toast("Email aktivasi telah dikirim. Mohon cek email Anda.", { type: "success" });
          setTimeout(() => {
            window.location.href = myApi.loginPath;
          }, 1500);
        })
        .catch((error) => {
          showLoading(false);
          toast(error.message, { type: "error" });
        });
    }
  } catch (error) {
    toast(error.message, { type: "error" });
  }

  showLoading(false);
};

const ForgotPasswordForm = () => {
  const [emailError, setEmailError] = useState('');

  return (
    <>
      <div className="auth-main-content m-auto m-1230 px-3">
        <Row className="align-items-center">
          <Col lg={6} className="d-none d-lg-block">
            <img
              src="/images/ejavec/side-04.jpg"
              className="rounded-3"
              alt="forgot"
              width={646}
              height={804}
            />
          </Col>

          <Col lg={6}>
            <div className="mw-480 ms-lg-auto">
              <div className="d-inline-block mb-4">
                <img
                  src="/images/ejavec/ejavec-logo.svg"
                  className="rounded-3 for-light-logo"
                  alt="login"
                  width={100}
                  height={26}
                />
                <img
                  src="/images/ejavec/ejavec-forum_sitelogo_2026.svg"
                  className="rounded-3 for-dark-logo"
                  alt="login"
                  width={100}
                  height={26}
                />
              </div>

              <h3 className="fs-28 mb-2">Forgot your password?</h3>
              <p className="fw-medium fs-16 mb-4">
                Enter the email address you used when you joined and we’ll send
                you instructions to reset your password.
              </p>

              <Form onSubmit={(e) => resetPassword(e, setEmailError)}>
                <Form.Group className="mb-4">
                  <FloatingLabel
                    controlId="floatingInput"
                    className="mb-3"
                    label="Email Address"
                  >
                    <Form.Control
                      type="email"
                      name="email"
                      className={`h-55 ${emailError ? 'is-invalid' : ''}`}
                      placeholder="mail@example.com "
                      required
                      onChange={(e) => {
                        if (emailError) {
                          const validation = validateEmail(e.target.value);
                          setEmailError(validation.valid ? '' : validation.message);
                        }
                      }}
                    />
                    {emailError && (
                      <Form.Control.Feedback type="invalid">{emailError}</Form.Control.Feedback>
                    )}
                  </FloatingLabel>
                </Form.Group>

                <Form.Group className="mb-4">
                  <button
                    type="submit"
                    className="btn btn-primary fw-medium py-2 px-3 w-100"
                  >
                    <div className="d-flex align-items-center justify-content-center py-1">
                      <span className="material-symbols-outlined fs-20 text-white me-2">
                        autorenew
                      </span>
                      <span>Send</span>
                    </div>
                  </button>
                </Form.Group>

                <Form.Group>
                  <p>
                    Back to{" "}
                    <Link
                      to="/auth/sign-in"
                      className="fw-medium text-primary text-decoration-none"
                    >
                      Sign In
                    </Link>
                  </p>
                </Form.Group>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ForgotPasswordForm;
